
import {} from "d3-color";
import { Prop, Ref } from "vue-property-decorator";
import ChartMixin from "../../helpers/mixins/chart";
export default class GaugeChart extends ChartMixin {
  @Ref("container") readonly container!: HTMLElement;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ type: Object, required: true }) chartData: any;
  @Prop({ type: Number }) split = 5;
  @Prop({ type: String }) tooltip: string = "";
}
